import Flex from "@/components/flex"
import DropdownHead from "@/routes/select/_components/dropdown/dropdown-head"
import DropdownItem from "@/routes/select/_components/dropdown/dropdown-item"
import DropDownItemWrapper from "@/routes/select/_components/dropdown/dropdown-item-wrapper"
import { useState } from "react"
import { aptSelectBundle } from "../apt-select-const"
import { langStore } from "@/stores/lang-store"

const AptAddressDropdown = ({
  tempAddr,
  setTempAddr,
  sidoList,
  sggList,
  roadList,
  onReset,
  onSearch
}) => {
  const [activeAddrTab, setActiveAddrTab] = useState("sido")
  const { lang } = langStore()
  const isSidoActive = activeAddrTab === "sido"
  const isSggActive = activeAddrTab === "sgg"
  const isRoadActive = activeAddrTab === "road"

  return (
    <article className="absolute top-2/5 md:top-full left-0 w-full mt-2 bg-white border border-slate-200 rounded-2xl shadow-2xl z-50 flex flex-col h-125 md:h-100 overflow-hidden text-sm">
      <div className="flex flex-col md:flex-row flex-1 overflow-hidden h-full">
        <Flex
          gap={0}
          className={`
            flex-col border-b md:border-b-0 md:border-r border-gray-100
            transition-all duration-300
            ${isSidoActive ? "flex-1" : "h-11 md:h-auto md:flex-1 shrink-0"}
          `}
        >
          <DropdownHead
            label={aptSelectBundle.filter.sido[lang]}
            onClick={() => setActiveAddrTab("sido")}
            isFold={!isSidoActive && tempAddr.sido}
            isActive={isSidoActive}
            foldLabel={tempAddr.sido === "전체" ? aptSelectBundle.filter.all[lang] : tempAddr.sido}
          />

          <DropDownItemWrapper active={isSidoActive}>
            <DropdownItem
              onClick={() => {
                setTempAddr({
                  sido: "전체",
                  sgg: "",
                  road: ""
                })
                setActiveAddrTab("sgg")
              }}
              active={tempAddr.sido === "전체"}
              label={aptSelectBundle.filter.all[lang]}
            />

            {[...sidoList].sort().map((sido) => (
              <DropdownItem
                key={sido}
                active={tempAddr.sido === sido}
                onClick={() => {
                  setTempAddr({
                    sido,
                    sgg: "",
                    road: ""
                  })
                  setActiveAddrTab("sgg")
                }}
                label={sido}
              />
            ))}
          </DropDownItemWrapper>
        </Flex>

        <Flex
          gap={0}
          className={`
            flex-col border-b md:border-b-0 md:border-r border-gray-100
            transition-all duration-300 bg-slate-50 md:bg-white
            ${isSggActive ? "flex-1" : "h-11 md:h-auto md:flex-1 shrink-0"}
          `}
        >
          <DropdownHead
            label={aptSelectBundle.filter.sgg[lang]}
            onClick={() => {
              if (tempAddr.sido) {
                setActiveAddrTab("sgg")
              }
            }}
            isFold={!isSggActive && tempAddr.sgg}
            isActive={isSggActive}
            foldLabel={tempAddr.sgg === "전체" ? aptSelectBundle.filter.all[lang] : tempAddr.sgg}
          />

          <DropDownItemWrapper active={isSggActive}>
            {tempAddr.sido && (
              <>
                {tempAddr.sido !== "전체" && (
                  <DropdownItem
                    active={tempAddr.sgg === "전체"}
                    onClick={() => {
                      setTempAddr({
                        ...tempAddr,
                        sgg: "전체",
                        road: ""
                      })
                      setActiveAddrTab("road")
                    }}
                    label={aptSelectBundle.filter.all[lang]}
                  />
                )}

                {sggList.map((sgg) => (
                  <DropdownItem
                    key={sgg}
                    active={tempAddr.sgg === sgg}
                    onClick={() => {
                      setTempAddr({
                        ...tempAddr,
                        sgg,
                        road: ""
                      })
                      setActiveAddrTab("road")
                    }}
                    label={sgg}
                  />
                ))}
              </>
            )}
          </DropDownItemWrapper>
        </Flex>

        <Flex
          gap={0}
          className={`
            flex-col transition-all duration-300
            ${isRoadActive ? "flex-1" : "h-11 md:h-auto md:flex-1 shrink-0"}
          `}
        >
          <DropdownHead
            label={aptSelectBundle.filter.road[lang]}
            onClick={() => {
              if (tempAddr.sgg) {
                setActiveAddrTab("road")
              }
            }}
            isFold={!isRoadActive && tempAddr.road}
            isActive={isRoadActive}
            foldLabel={tempAddr.road === "전체" ? aptSelectBundle.filter.all[lang] : tempAddr.road}
          />

          <DropDownItemWrapper active={isRoadActive}>
            {tempAddr.sgg && (
              <>
                {tempAddr.sgg !== "전체" && (
                  <DropdownItem
                    active={tempAddr.road === "전체"}
                    onClick={() => {
                      setTempAddr({
                        ...tempAddr,
                        road: "전체"
                      })
                    }}
                    label={aptSelectBundle.filter.all[lang]}
                  />
                )}

                {roadList.map((road) => (
                  <DropdownItem
                    key={road}
                    active={tempAddr.road === road}
                    onClick={() => {
                      setTempAddr({
                        ...tempAddr,
                        road
                      })
                    }}
                    label={road}
                  />
                ))}
              </>
            )}
          </DropDownItemWrapper>
        </Flex>
      </div>

      <div className="p-2 bg-slate-50 border-t border-slate-100 flex justify-end gap-2 shrink-0">
        {/* 리셋 */}
        <button
          onClick={() => {
            setActiveAddrTab("sido")
            onReset?.()
          }}
          className="px-4 py-2 bg-white border border-slate-300 rounded-lg font-medium text-slate-600 hover:bg-slate-100 transition-colors cursor-pointer"
        >
          {aptSelectBundle.filter.reset[lang]}
        </button>

        {/* 검색 */}
        <button
          onClick={() => onSearch()}
          className="px-6 py-2 bg-blue-600 text-white rounded-lg font-bold hover:bg-blue-700 shadow-md shadow-blue-200 transition-all cursor-pointer"
        >
          {aptSelectBundle.filter.apply[lang]}
        </button>
      </div>
    </article>
  )
}

export default AptAddressDropdown
